import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { ConversationSummary } from '@/types/api'

interface ConversationState {
  conversations: ConversationSummary[]
  activeConversationId: string | null

  setConversations: (list: ConversationSummary[]) => void
  setActiveConversation: (id: string | null) => void
  addConversation: (conv: ConversationSummary) => void
  removeConversation: (id: string) => void
  updateConversation: (id: string, patch: Partial<ConversationSummary>) => void
}

export const useConversationStore = create<ConversationState>()(
  persist(
    (set) => ({
      conversations: [],
      activeConversationId: null,

      setConversations: (list) => set({ conversations: list }),

      setActiveConversation: (id) => set({ activeConversationId: id }),

      addConversation: (conv) =>
        set((state) => ({ conversations: [conv, ...state.conversations] })),

      removeConversation: (id) =>
        set((state) => ({
          conversations: state.conversations.filter((c) => c.id !== id),
          activeConversationId:
            state.activeConversationId === id ? null : state.activeConversationId,
        })),

      updateConversation: (id, patch) =>
        set((state) => ({
          conversations: state.conversations.map((c) =>
            c.id === id ? { ...c, ...patch } : c
          ),
        })),
    }),
    {
      name: 'uai-conversations',
      partialize: (state) => ({
        conversations: state.conversations.slice(0, 100),
        activeConversationId: state.activeConversationId,
      }),
    }
  )
)
